import { service } from '@ember/service';
import { action } from '@ember/object';

export default class AuthHandler {
  @service session;
  @service router;

  @action
  async request({ request }, next) {
    if (
      !this.session.isAuthenticated ||
      !this.session.data.authenticated?.access_token
    ) {
      return next(request);
    }

    const headers = new Headers(request.headers);

    headers.append(
      'Authorization',
      `Bearer ${this.session.data.authenticated.access_token}`,
    );

    try {
      const response = await next(Object.assign({}, request, { headers }));
      return response;
    } catch (error) {
      if (error.status === 401) {
        this.session.invalidate();
      }
      throw error;
    }
  }
}
